/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {
  GetMazdaWarrantyAssemblyGroupsApiResponse,
  GetMazdaWarrantyCausalPartsApiResponse,
  GetMazdaWarrantyDamagesApiResponse,
  GetMazdaWarrantyLocationsApiResponse,
  GetMazdaWarrantySubAssemblyGroupsApiResponse,
  GetMazdaWarrantySubletsApiResponse,
  GetMazdaWarrantySymptomsApiResponse,
} from '../types';

export const mazdaWarrantyAssemblyGroupsMockResponse: GetMazdaWarrantyAssemblyGroupsApiResponse = {
  assemblyGroups: [
    {code: 'A', description: 'A - Maintenance and adjustment'},
    {code: 'B', description: 'B - Reciprocating Engine'},
  ],
};

export const mazdaWarrantySubAssemblyGroupsMockResponse: GetMazdaWarrantySubAssemblyGroupsApiResponse =
  {
    subAssemblyGroups: [{code: 'A01', description: 'A01 - Maintenance and adjustment'}],
  };

export const mazdaWarrantySymptomsMockResponse: GetMazdaWarrantySymptomsApiResponse = {
  symptoms: [{code: '01', description: '01 - Engine does not start'}],
};

export const mazdaWarrantyDamagesMockResponse: GetMazdaWarrantyDamagesApiResponse = {
  damages: [{code: '91', description: '91 - Oil or lubricant leak'}],
};

export const mazdaWarrantyLocationsMockResponse: GetMazdaWarrantyLocationsApiResponse = {
  locations: [
    {code: 'FRT', description: 'FRT - Front'},
    {code: 'RER', description: 'RER - Rear'},
  ],
};

export const mazdaWarrantyCausalPartsMockResponse: GetMazdaWarrantyCausalPartsApiResponse = {
  causalParts: [{code: 'B0101H', description: 'B0101H - Cylinder block'}],
};

export const mazdaWarrantySubletsMockResponse: GetMazdaWarrantySubletsApiResponse = {
  sublets: [{code: 'A1', description: 'A1 - Lak'}],
};
